class UserApiKeyRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.path = 'v1/users/api/keys';
  }
  getCurrentApiKey() {
    return this.apiClient.get(this.path).then(response => response.data);
  }
  generateNewApiKey() {
    return this.apiClient.post(this.path).then(response => response.data);
  }
  revokeCurrentApiKey() {
    return this.apiClient.delete(this.path).then(response => response.data);
  }
}

export { UserApiKeyRepository };
//# sourceMappingURL=UserApiKeyRepository.js.map
